export const Color: Record<number, string> = {
  0: `#bbff9e`,
  1: `#9eecff`,
  2: `#bd9eff`,
  3: `#ff9e9e`,
  4: `#ffdb9e`,
};
